/**
 * Converts number of days/hours/minutes etc. to milliseconds
 */
export const toMillis = (count: number, from: 'week' | 'day' | 'hour' | 'min' | 'sec') => {
  const fromSec = count * 1000;
  const fromMin = fromSec * 60;
  const fromHour = fromMin * 60;
  const fromDay = fromHour * 24;
  const fromWeek = fromDay * 7;

  switch (from) {
    case 'sec':
      return fromSec;
    case 'min':
      return fromMin;
    case 'hour':
      return fromHour;
    case 'day':
      return fromDay;
    case 'week':
      return fromWeek;
  }
};

/**
 * Converts number of days/hours/minutes etc. to seconds
 */
export const toSeconds = (...args: Parameters<typeof toMillis>) => toMillis(...args) / 1000;

/**
 * Parses ISO8601 duration string and returns duration in milliseconds
 * Example: 'P1Y2M3DT4H5M6S' -> 1 year, 2 months, 3 days, 4 hours, 5 minutes, 6 seconds
 * @param duration ISO8601 duration string
 * @returns Duration in milliseconds
 */
export function parseISODuration(duration: string): number {
  const regex =
    /P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?/;
  const matches = duration.match(regex);

  if (!matches) {
    throw new Error(`Invalid ISO8601 duration format: ${duration}`);
  }

  const [, years, months, weeks, days, hours, minutes, seconds] = matches;

  const now = new Date();
  const result = now.getTime();

  const future = new Date(now);
  if (years) future.setFullYear(future.getFullYear() + parseInt(years));
  if (months) future.setMonth(future.getMonth() + parseInt(months));
  if (weeks) future.setDate(future.getDate() + parseInt(weeks) * 7);
  if (days) future.setDate(future.getDate() + parseInt(days));
  if (hours) future.setHours(future.getHours() + parseInt(hours));
  if (minutes) future.setMinutes(future.getMinutes() + parseInt(minutes));
  if (seconds) future.setSeconds(future.getSeconds() + parseInt(seconds));

  return future.getTime() - result;
}
